var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomnavHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_25192"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M200.25,222.38H63.78c-12.64,0-22.93-10.29-22.93-22.93V92.23c0-1.06,.49-2.06,1.32-2.71L129.91,21.28c1.24-.96,2.97-.96,4.21,0l87.74,68.24c.83,.65,1.32,1.65,1.32,2.71v107.23c0,12.64-10.29,22.93-22.93,22.93ZM47.71,93.9v105.55c0,8.86,7.21,16.07,16.07,16.07H200.25c8.86,0,16.07-7.21,16.07-16.07V93.9L132.02,28.33,47.71,93.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_25193"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M161.27,222.39c-1.9,0-3.43-1.53-3.43-3.43V124.9h-51.63v94.06c0,1.9-1.53,3.43-3.43,3.43s-3.43-1.53-3.43-3.43V121.47c0-1.9,1.53-3.43,3.43-3.43h58.49c1.9,0,3.43,1.53,3.43,3.43v97.49c0,1.9-1.53,3.43-3.43,3.43Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomnavHome);
export default __webpack_public_path__ + "static/media/bottomnav-home.c74bdea31e7cd78911f8420073aad911.svg";
export { ForwardRef as ReactComponent };